import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { textPrimary } from 'app/components/ThemeProvider/colors';

const CheckmarkIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox='0 0 24 24'
      fill='none'
      sx={{ width: '24px', height: '24px', fill: 'none', ...sx }}
      {...props}
    >
      <path
        d='M5 12.4L9.5 16.81L19 7.19'
        fill='none'
        stroke={textPrimary}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
};

export default CheckmarkIcon;
